import React, {FC, ReactNode} from 'react';
import {HelmetProvider} from './react-helmet-async';
import type {HelmetServerState} from './react-helmet-async';

export type HeadContext = {
  helmet?: HelmetServerState;
};

export const HeadElementsProvider: FC<
  React.PropsWithChildren<{
    children?: ReactNode;
    headContext: HeadContext;
  }>
> = ({children, headContext}) => {
  return <HelmetProvider context={headContext}>{children}</HelmetProvider>;
};
